namespace TabAurous.OMS {
    export namespace AttributeMasterService {
        export const baseUrl = 'OMS/AttributeMaster';

        export declare function Create(request: Serenity.SaveRequest<AttributeMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<AttributeMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListAttributes(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AttributeReportFilterList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetAttributesByType(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/AttributeMaster/Create",
            Update = "OMS/AttributeMaster/Update",
            Delete = "OMS/AttributeMaster/Delete",
            Retrieve = "OMS/AttributeMaster/Retrieve",
            List = "OMS/AttributeMaster/List",
            ListAttributes = "OMS/AttributeMaster/ListAttributes",
            AttributeReportFilterList = "OMS/AttributeMaster/AttributeReportFilterList",
            GetAttributesByType = "OMS/AttributeMaster/GetAttributesByType"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ListAttributes', 
            'AttributeReportFilterList', 
            'GetAttributesByType'
        ].forEach(x => {
            (<any>AttributeMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
